import { type PartialDeep } from 'type-fest';

import { type CanvasElementFrom, type PropsOf } from '@blaze-runtime/engine-domain';

import {
  getSourceProps,
  getSourceTransforms,
} from '../../canvas-elements/element-model/transformations';
import { parkedToggleButtonProps } from '../toggle-button/toggle-button.transforms';
type CheckboxInputElement = CanvasElementFrom<'checkboxInput'>;
type CheckboxInputProps = PartialDeep<PropsOf<'checkboxInput'>>;

function transformRadioToCheckboxInput(source: CanvasElementFrom<'radio'>): CheckboxInputElement {
  const props: PartialDeep<PropsOf<'radio'>> = source.props || {};
  const newProps: CheckboxInputProps = {
    content: {
      title: {
        enabled: props.content?.title?.enabled,
        label: props.content?.title?.label,
        position: props.content?.title?.position,
        align: props.content?.title?.align,
        width: props.content?.title?.width,
        icon: props.content?.title?.icon,
        iconPosition: props.content?.title?.iconPosition,
        tooltip: props.content?.title?.tooltip,
      },
      input: {
        readonly: props.content?.radio?.readonly,
      },
    },
    style: {
      fontSize: props.style?.fontSize,
      general: {
        title: props.style?.general?.title,
        accent: props.style?.general?.accent,
      },
      input: {
        symbol: props.style?.radio?.label,
        fill: props.style?.radio?.fill,
        border: props.style?.radio?.border,
        radius: undefined, // no mapping
      },
    },
  };

  // TODO: fix type
  return { props: newProps } as any;
}

function transformToggleButtonToCheckboxInput(
  source: CanvasElementFrom<'toggleButton'>,
): CheckboxInputElement {
  const props = getSourceProps(source);
  const propsT = getSourceTransforms<'toggleButton', 'checkboxInput'>(source, 'checkboxInput');
  const newProps: CheckboxInputProps = {
    content: {
      title: { ...props.content?.title },
      input: {
        readonly: propsT?.content?.input?.readonly,
      },
    },
    style: {
      fontSize: propsT?.style?.fontSize,
      fontFamily: propsT?.style?.fontFamily,
      lineHeight: propsT?.style?.lineHeight,
      general: {
        title: props.style?.general?.title,
        accent: propsT?.style?.general?.accent,
        offset: props.style?.button?.offset,
      },
      labelBlock: props.style?.labelBlock,
      input: {
        symbol: propsT?.style?.input?.symbol,
        fill: propsT?.style?.input?.fill,
        border: propsT?.style?.input?.border,
        radius: propsT?.style?.input?.radius,
      },
    },
    transforms: {
      toggleButton: parkedToggleButtonProps(props),
    },
  };

  return { props: newProps } as unknown as CheckboxInputElement;
}

export const transformToCheckboxInput = {
  transformRadioToCheckboxInput,
  transformToggleButtonToCheckboxInput,
};
